import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { WiMuleSQL } from "../../services/WiMuleSQL";

const postLunchMeal = async (mealData) => {
  const response = await axios.post(
    `${WiMuleSQL}/api/LunchMenu/PostLunchMeal`,
    mealData
  );
  return response.data;
};

export const usePostLunchMeal = () =>
  useMutation({
    mutationFn: postLunchMeal,
  });
